import { FormBuilder } from '@angular/forms';
var Tipo_propiedadComponent = /** @class */ (function () {
    function Tipo_propiedadComponent(fb) {
        this.fb = fb;
        this.rows = [];
        //public tipos: string[] =['URBANO','RURAL'];
        this.tipos = { "urbano": false, "rural": false };
        if (!JSON.parse(localStorage.getItem("tipo_propiedad"))) {
            localStorage.setItem("tipo_propiedad", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("tipo_propiedad"));
            this.tipos = {
                "urbano": this.rows[0] ? this.rows[0].tpradio.urbano : false,
                "rural": this.rows[0] ? this.rows[0].tpradio.rural : false
            };
        }
        /* this.form = new FormGroup({
             options: new FormControl('', Validators.required)
         })*/
    }
    Tipo_propiedadComponent.prototype.add_tipo_propiedad = function () {
        //console.log(event)
        // var checkTipoPropiedad = event.value;
        console.log(this.tipos);
        localStorage.setItem("tipo_propiedad", JSON.stringify([]));
        this.actualRow = localStorage.getItem("tipo_propiedad");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            tpradio: this.tipos
        });
        localStorage.setItem("tipo_propiedad", JSON.stringify(this.rows));
    };
    Tipo_propiedadComponent.prototype.delete_tipo_propiedad = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("tipo_propiedad", JSON.stringify(this.rows));
            }
        }
    };
    return Tipo_propiedadComponent;
}());
export { Tipo_propiedadComponent };
